import apiClient from './client';
import type { LLCurve, LLDaily, LLFilters, LLPages, LLRequest, LLSummary, LeadLifetimePreset } from '@/types/lead-lifetime';

/**
 * API de Relatórios > Vida útil do lead (ms-api-system /reports/lead-lifetime/*).
 * `objective` vai repetido (objective=A&objective=B), que é o que o backend espera —
 * por isso o paramsSerializer sem colchetes.
 */
const SERIALIZER = { indexes: null } as const;

const params = (req: LLRequest): Record<string, any> => {
    const out: Record<string, any> = { preset: req.preset };
    if (req.project_id) out.project_id = req.project_id;
    if (req.page_id) out.page_id = req.page_id;
    if (req.objective?.length) out.objective = req.objective;
    return out;
};

const get = async <T,>(kind: string, req: LLRequest): Promise<T> => {
    const response = await apiClient.get<T>(`/reports/lead-lifetime/${kind}`, {
        params: params(req),
        paramsSerializer: SERIALIZER,
    });
    return response.data;
};

export const getLeadLifetimeSummary = (req: LLRequest) => get<LLSummary>('summary', req);
export const getLeadLifetimeCurve = (req: LLRequest) => get<LLCurve>('curve', req);
export const getLeadLifetimeDaily = (req: LLRequest) => get<LLDaily>('daily', req);
export const getLeadLifetimePages = (req: LLRequest) => get<LLPages>('pages', req);

export const getLeadLifetimeFilters = async (preset: LeadLifetimePreset, projectId?: number): Promise<LLFilters> => {
    const response = await apiClient.get<LLFilters>('/reports/lead-lifetime/filters', {
        params: { preset, ...(projectId ? { project_id: projectId } : {}) },
    });
    return response.data;
};
